function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { i18n, SessionSelectors } from 'invision-core';
import LocaleKeys from '../../../locales/keys';
import { RouteParams } from '../../../reducers/selectors/customer.selectors';
import { CurrentRedemptionDetailsAssociationCardsDataSelector } from '../../../reducers/selectors/customer.coupons.selectors';
import { CurrentRedemptionDetailsSelector, CouponRedemptionCodeErrorSelector, IsRedemptionCodeGlobalSelector } from '../../../reducers/selectors/coupon.redemption.code.selectors';
import { retrieveRedemptionCodeDetails } from '../../../reducers/actions/customer.coupons.actions';
import { updateCouponRedemptionCodeExpiration } from '../../../reducers/actions/coupon.redemption.code.actions';
var RedemptionCodeDetailsController = /*#__PURE__*/function () {
  function RedemptionCodeDetailsController($ngRedux, $timeout, $q, uiNotificationService) {
    _classCallCheck(this, RedemptionCodeDetailsController);
    this.$ngRedux = $ngRedux;
    this.$timeout = $timeout;
    this.$q = $q;
    this.uiNotificationService = uiNotificationService;
  }
  return _createClass(RedemptionCodeDetailsController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.CustomerLocaleKeys = LocaleKeys;
      this.detailsTabs = [];
      if (!this.isGlobal) {
        this.detailsTabs.push({
          id: 'general',
          name: i18n.translate(this.CustomerLocaleKeys.COUPONS.REDEMPTION_CODE_DETAILS.TAB_LABELS.GENERAL),
          active: true
        });
      }
      this.detailsTabs.push({
        id: 'associations',
        name: i18n.translate(this.CustomerLocaleKeys.COUPONS.REDEMPTION_CODE_DETAILS.TAB_LABELS.ASSOCIATIONS),
        active: this.isGlobal
      });
      this.detailsTabs.push({
        id: 'redemptions',
        name: i18n.translate(this.CustomerLocaleKeys.COUPONS.REDEMPTION_CODE_DETAILS.TAB_LABELS.REDEMPTIONS),
        active: false
      });
      this.mapStateToTarget = function (store) {
        return {
          currentRedemptionDetails: CurrentRedemptionDetailsSelector(store),
          currentRedemptionDetailsAssociationCardsData: CurrentRedemptionDetailsAssociationCardsDataSelector(store),
          isRedemptionCodeGlobal: IsRedemptionCodeGlobalSelector(store),
          lastAttemptError: CouponRedemptionCodeErrorSelector(store),
          routeParams: RouteParams(store),
          userSecurityAttributes: SessionSelectors.UserSecurityAttributesSelector(store)
        };
      };
      this.controllerActions = {
        retrieveRedemptionCodeDetails: retrieveRedemptionCodeDetails,
        updateCouponRedemptionCodeExpiration: updateCouponRedemptionCodeExpiration
      };
      this.disconnectRedux = this.$ngRedux.connect(this.mapStateToTarget, this.controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      if (this.shouldRequestRedemptionCodeDetails()) {
        this.actions.retrieveRedemptionCodeDetails(this.state.routeParams.customerId, this.state.routeParams.couponRedemptionCodeId);
      }
      this.selectedTab = this.detailsTabs[0];
    }
  }, {
    key: "shouldRequestRedemptionCodeDetails",
    value: function shouldRequestRedemptionCodeDetails() {
      return !this.state.currentRedemptionDetails || this.currentRedemptionCodeDoesNotHaveRedemptionCount;
    }
  }, {
    key: "currentRedemptionCodeDoesNotHaveRedemptionCount",
    get: function get() {
      return !this.state.currentRedemptionDetails.RedemptionCode.RedemptionsCount;
    }
  }, {
    key: "tabSelected",
    value: function tabSelected(_tabSelected) {
      var _this2 = this;
      this.detailsTabs.forEach(function (detailTab) {
        if (detailTab.id === _tabSelected.id) {
          detailTab.active = true;
          _this2.selectedTab = _tabSelected;
        } else {
          detailTab.active = false;
        }
      });
    }
  }, {
    key: "updateExpirationDate",
    value: function updateExpirationDate(date) {
      var _this3 = this;
      this.actions.updateCouponRedemptionCodeExpiration(this.state.routeParams.couponRedemptionCodeId, date, this.state.currentRedemptionDetails.RedemptionCode.Status).then(function () {
        _this3.uiNotificationService.success(i18n.translate(LocaleKeys.COUPONS.REDEMPTION_CODE_DETAILS.LABELS.UPDATE_EXPIRATION_DATE_SUCCESS_MESSAGE));
      });
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  bindings: {
    isGlobal: '<'
  },
  template: require('./redemption.code.details.html'),
  controller: RedemptionCodeDetailsController
};